import { Injectable, Injector } from '@angular/core';
import { AccessGroup } from '@carm/_core';
import { UserService } from '../../../../../_core/access-control-mgt/facade/user.service';
import {
  Program,
  Role,
  UserRole,
} from '../../../../../_core/access-control-mgt/models/user-role.model';
import {
  AllOrIndividualPrograms,
  IGrantAccessRequestsViewForm,
} from '../models/grant-access.model';
import { IUserRequest } from '../models/user-request.model';

@Injectable()
export class GrantAccessRequestsStateService {
  // set by the manage user requests screen
  userRequests: IUserRequest[] = [];

  // get from the roles api
  programsList: Program[];

  // represents the form in the grant-access component, stored here so it is possible to navigate
  // back and forth in the select access and confirm screens
  public grantAccessViewForm: IGrantAccessRequestsViewForm;

  userRole: UserRole;

  nativeRoles: Role[];

  public businessUid: string;

  constructor(
    protected injector: Injector,
    protected userService: UserService
  ) {
    this.initialize();
  }

  public initialize() {
    this.userRole = this.userService.getUserRolesSync();
    this.nativeRoles = this.userService.getUserNativeRolesSync();

    this.businessUid = this.userRole?.business?.uid;

    // we need only the programs for the native business
    this.programsList = this.nativeRoles
      .filter(r => this.isNativeBamOrPamRole(r, this.userRole.business.uid))
      .map(r => r.program)
      .sort((a, b) => (a.name < b.name ? -1 : 1));

    this.initializeGrantAccessViewForm(this.programsList);
  }

  public reset(): void {
    this.userRole = null;
    this.nativeRoles = null;
    this.businessUid = null;
    this.programsList = null;
    this.userRequests = null;
  }

  private isNativeBamOrPamRole(role: Role, nativeCompanyUid: string) {
    return (
      role.roleType.toString().indexOf('BUSINESS_ACCOUNT_MANAGER') >= 0 ||
      role.roleType.toString().indexOf('PROGRAM_ACCOUNT_MANAGER') >= 0
    );
  }

  public initializeGrantAccessViewForm(programsList: Program[]) {
    this.grantAccessViewForm = {
      allOrIndividualPrograms: AllOrIndividualPrograms.all,
      allProgramsAccessGroupControl: null,
      programsAccessGroups: [],
    };

    programsList.forEach(pgm => {
      this.grantAccessViewForm.programsAccessGroups.push({
        programInfo: pgm,
        accessGroup: null,
      });
    });
  }

  public setUserRequests(userRequests: IUserRequest[]) {
    this.initialize();
    this.userRequests = userRequests;
  }

  public getUserRequests(): IUserRequest[] {
    return this.userRequests;
  }

  public getProgramsList(): Program[] {
    return this.programsList;
  }

  public canApproveRequests(): boolean {
    return (
      (this.grantAccessViewForm.allOrIndividualPrograms ===
        AllOrIndividualPrograms.all &&
        this.grantAccessViewForm.allProgramsAccessGroupControl ===
          AccessGroup.BusinessAccountManager) ||
      this.grantAccessViewForm.programsAccessGroups.filter(
        ag => ag.accessGroup !== AccessGroup.NoAccess && ag.accessGroup !== null
      ).length > 0
    );
  }
}
